import $ from 'jquery';
import '@fancyapps/fancybox';
import Masonry from 'masonry-layout';
import 'slick-carousel';
import '../components/words/intro';
import '../components/menu';
import '../../sass/gallery.scss';

$(document).ready(function () {
	if ($('body').hasClass('page-template-gallery')) {
		let href = window.location.href;
		let pathinfo = href.split('?')[1];
		if (pathinfo == 'tab=tours') {
			activateTours();
		} else {
			activatePhotos();
		}

		$(document).on('click', '.tabs .item', function () {
			let tab = $(this).data('tab');
			$(this).addClass('active').siblings().removeClass('active');
			switch (tab) {
				case 'Photos':
					activatePhotos();
					break;
				case 'Tours':
					activateTours();
					break;
			}
		});

		function activatePhotos() {
			$('.ucg-gallery .tabs .item-photos')
				.addClass('active')
				.siblings()
				.removeClass('active');
			$('.ucg-gallery .filter-photos')
				.addClass('active')
				.siblings()
				.removeClass('active');
			$('.ucg-gallery .photos').addClass('active');
			$('.ucg-gallery .tours').removeClass('active');
			var masonryGallery = document.querySelector('#ucg_gallery');
			if (masonryGallery) {
				setTimeout(function () {
					let gutterSetting = masonryGallery.dataset.gutter;
					let masonryGrid = new Masonry(masonryGallery, {
						columnWidth: '.grid-item',
						fitWidth: true,
						gutter: Number(gutterSetting),
						itemSelector: '.grid-item',
					});
				}, 1000);
			}
			if ($('.ucg-gallery .photos.carousel .slides').children().length > 1) {
				$('.ucg-gallery .photos.carousel .slides').slick({
					arrows: false,
					autoplay: false,
					centerMode: true,
					cssEase: 'ease-in-out',
					dots: true,
					infinite: true,
					variableWidth: true,
					speed: 1000,
					slidesToShow: 3,
				});
			}
			if (
				$('.ucg-gallery .photos.carousel .navigator .thumbnails').children()
					.length > 1
			) {
				$('.ucg-gallery .photos.carousel .navigator .thumbnails').slick({
					arrows: true,
					asNavFor: '.ucg-gallery .photos.carousel .slides',
					autoplay: false,
					autoplaySpeed: 5000,
					centerMode: true,
					dots: false,
					focusOnSelect: true,
					infinite: true,
					nextArrow:
						'<p class="slick-next"><i class="fa fa-angle-right"></i></p>',
					pauseOnHover: false,
					pauseonFocus: false,
					prevArrow:
						'<p class="slick-prev"><i class="fa fa-angle-left"></i></p>',
					slidesToScroll: 1,
					slidesToShow: 5,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 5,
								slidesToScroll: 5,
							},
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							},
						},
					],
					speed: 1000,
				});
			}
		}

		function activateTours() {
			$('.ucg-gallery .tabs .item-tours')
				.addClass('active')
				.siblings()
				.removeClass('active');
			$('.ucg-gallery .filter-tours')
				.addClass('active')
				.siblings()
				.removeClass('active');
			$('.ucg-gallery .tours').addClass('active');
			$('.ucg-gallery .photos').removeClass('active');
		}
	}
});
